<template>
  <div class="input-group">
    <span class="input-group-text">
      <i class="bi bi-search"></i>
    </span>

    <input
      :id="id"
      type="text"
      class="form-control"
      :placeholder="placeholder"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />

    <button
      v-if="modelValue"
      class="btn btn-outline-secondary"
      type="button"
      @click="onClear"
      :title="clearTitle"
    >
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

defineProps({
  modelValue: { type: String, default: "" },
  id: { type: String, default: "search" },
  placeholder: { type: String, default: "Vyhledat..." },
  clearTitle: { type: String, default: "Vymazat vyhledávání" },
});

const emit = defineEmits(["update:modelValue", "clear"]);

const onClear = () => {
  emit("update:modelValue", "");
  emit("clear");
};
</script>

<style scoped>
</style>
